var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { priceDisplayModeToggleRouting } from '@honeycomb/routing';
import { RadioToggle, RadioToggleButton, Styler } from '@honeycomb/ui-core';
import React from 'react';
import { PriceDisplayMode, useGlobalContext, usePriceDisplayMode } from '@honeycomb/data';
import { useDebounce } from '../../utils/useDebounce';
export function PriceDisplayModeToggle(_a) {
    var props = __rest(_a, []);
    const { resourceStrings: { PRICEMODETOGGLE_TOTAL, PRICEMODETOGGLE_PERPERSON }, } = useGlobalContext();
    const [currentPriceMode, setCurrentPriceMode] = usePriceDisplayMode();
    const [value, setValue] = React.useState(currentPriceMode);
    const handlePriceToggle = useDebounce((newMode) => {
        setCurrentPriceMode(newMode);
        priceDisplayModeToggleRouting(newMode);
    }, 300);
    const handleChangeValue = React.useCallback((newValue) => {
        // Update the local state to re-render the toggle
        setValue(newValue);
        // Call the debounced update
        handlePriceToggle(newValue);
    }, [handlePriceToggle]);
    return (React.createElement(Styler, { fontSize: "12px" },
        React.createElement(RadioToggle, Object.assign({ value: value, onChangeValue: handleChangeValue }, props),
            React.createElement(RadioToggleButton, { value: PriceDisplayMode.TotalPrice, "data-id": "price-toggle-total" }, PRICEMODETOGGLE_TOTAL),
            React.createElement(RadioToggleButton, { value: PriceDisplayMode.PerPersonPrice, "data-id": "price-toggle-per-person" }, PRICEMODETOGGLE_PERPERSON))));
}
